import React from "react";
import { type NextPage } from "next";
import { Box } from "@chakra-ui/react";
import { Page } from "components/page";
import { sectionSpacingY } from "components/section";
import { StackedLogos } from "components/logos";
import { PricingHeroBg, PricingCards, PricingTables, Faq } from "components/pricing";
import { getLandingPageProps, getPageMetaImage, type LandingPageProps } from "utils";
import { TextTitle } from "ui/text";
import { Container } from "ui/container";
import { CenteredQuote } from "components/quotes";
import { AuraPlate } from "ui/plates";

const Pricing: NextPage<LandingPageProps> = ({ page, announcementBanner, defaultLogos, defaultMobileLogos }) => {
  return (
    <Page
      title={page.metaTitle}
      description={page.metaDescription}
      image={getPageMetaImage({ src: page.metaImageUrl, alt: page.metaTitle })}
      announcementBanner={announcementBanner}
      bgColor="new.blue.150"
      footerOptions={{ variant: "blue" }}
    >
      <Box as="section" pos="relative" pt={{ base: "big", md: "biggest" }}>
        <PricingHeroBg />
        <Container pos="relative">
          <TextTitle
            align="center"
            mobileAlign="center"
            size="xl"
            titleAs="h1"
            chip={{ text: page.eyebrow }}
            title={page.title}
          />

          <PricingCards />
        </Container>
      </Box>

      <StackedLogos customers={defaultLogos} mobileCustomers={defaultMobileLogos} mb={sectionSpacingY} />

      <PricingTables />

      <AuraPlate condensed theme="light" variant="blue" my={sectionSpacingY}>
        <CenteredQuote
          maxW="970px"
          quoteText="One of the big value props of Hightouch is time-to-value. We’ve seen a lot of value very quickly."
          author={{ name: "Natalie Miles", job: "Head of Marketing Technology and Personalization" }}
          company={{
            name: "Chime",
            logo: "https://cdn.sanity.io/images/pwmfmi47/production/0bfab275e65467db361389702dbb62cb2f01b24c-1106x316.png",
            logoRatio: 5 / 1,
          }}
        />
      </AuraPlate>

      <Faq />
    </Page>
  );
};

export default Pricing;

export const getStaticProps = getLandingPageProps("/pricing", {
  loadDefaultLogos: true,
  loadDefaultMobileLogos: true,
});
